module.exports = __webpack_public_path__ + "img/la-clairiere-des-livres.6a1bc4be.png";